<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { use_notify } from '@/stores/notify'
  import { storeToRefs as to_refs } from 'pinia'

  const show = ref(false)
  const { notify } = use_notify()
  const { content, snackbar_color } = to_refs(use_notify())

  watch(content, new_content => {
    if (new_content) show.value = true
  })

  const on_snackbar_close = (value: boolean) => {
    if (!value) notify('')
  }
</script>

<template>
  <v-snackbar
    v-model="show"
    :color="snackbar_color"
    :timeout="3000"
    location="center"
    variant="elevated"
    @update:model-value="on_snackbar_close">
    <h3 class="text-h6 rounded">{{ content }}</h3>
  </v-snackbar>
</template>
